import React from 'react';
import { ArrowUpDown } from 'lucide-react';
import { cn } from '../../utils/cn';
import {
  CREATED_AT_SORT_NEWEST,
  CREATED_AT_SORT_OLDEST,
  LESSON_SORT_LESSON_NUMBER,
  LESSON_CONTENT_SORT_LESSON_ORDER,
} from '../../utils/displayOrder.js';

export const CREATED_AT_SORT_OPTIONS = [
  { value: CREATED_AT_SORT_OLDEST, label: 'Oldest first' },
  { value: CREATED_AT_SORT_NEWEST, label: 'Newest first' },
];

export const TAG_SORT_OPTIONS = [...CREATED_AT_SORT_OPTIONS, { value: 'name', label: 'Name A–Z' }];

export const LESSON_SORT_OPTIONS = [
  { value: LESSON_SORT_LESSON_NUMBER, label: 'Lesson order' },
  ...CREATED_AT_SORT_OPTIONS,
];

export const LESSON_CONTENT_SORT_OPTIONS = [
  { value: LESSON_CONTENT_SORT_LESSON_ORDER, label: 'Lesson order' },
  ...CREATED_AT_SORT_OPTIONS,
];

/** Book-wide All Elements / All Exercises lists (same modes as lesson content). */
export const BOOK_CONTENT_SORT_OPTIONS = [
  { value: LESSON_CONTENT_SORT_LESSON_ORDER, label: 'Curriculum order' },
  ...CREATED_AT_SORT_OPTIONS,
];

export const NAME_SORT_AZ = 'name-az';

export const USER_DISPLAY_SORT_OPTIONS = [
  ...CREATED_AT_SORT_OPTIONS,
  { value: NAME_SORT_AZ, label: 'Name A–Z' },
];

export function ListSortSelect({
  value,
  onChange,
  options = CREATED_AT_SORT_OPTIONS,
  label = 'Sort by',
  className,
  id,
  sortId,
}) {
  const selectId = id || sortId || 'list-sort';
  return (
    <div className={cn('flex items-center gap-2 shrink-0', className)}>
      <label htmlFor={selectId} className="sr-only">
        {label}
      </label>
      <ArrowUpDown className="hidden h-4 w-4 text-slate-400 sm:block" aria-hidden />
      <select
        id={selectId}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        aria-label={label}
        className="min-h-[44px] w-full min-w-[9.5rem] rounded-xl border border-slate-300 bg-white px-3 py-2.5 text-sm font-medium text-slate-800 focus:outline-none focus:ring-2 focus:ring-indigo-500 sm:w-auto"
      >
        {options.map((opt) => (
          <option key={opt.value} value={opt.value}>
            {opt.label}
          </option>
        ))}
      </select>
    </div>
  );
}
